import { FormGroup } from '@ksyos/design-system';
import {
    BeleidOptions,
    UrgenciesForConsultOogartsEnum,
    UrgenciesForConsultOptometrist,
} from '@common/validation/customControls/ophthalmology';
import { InputPeriod } from '@frontend/components/elements/InputPeriod';
import type { IOrthOV1DiagnosticReportAddEditCustomControlFieldsProps } from './OrthOV1DiagnosticReportAddEditCustomControlFields';
import { HeaderDivider } from '../../../elements/common';
import { SearchableEnumDropdown } from '../../../elements/SearchableEnumDropdown';
import { InputTextField } from '../../../userDataManagement/InputText';
import { beleidInitialValues } from './OrthOV1DiagnosticReportAddEditCustomControlFields';

export function OrthOV1DiagnosticReportAddEditCustomControlDataBeleid(
    props: IOrthOV1DiagnosticReportAddEditCustomControlFieldsProps
) {
    return (
        <>
            <HeaderDivider text="Beleid" />
            <FormGroup
                hasErrors={props.errors.has('customControlData.geadviseerd_beleid')}
                isRequired={true}
                label="Geadviseerd beleid"
            >
                <SearchableEnumDropdown
                    automation="beleid"
                    error={props.errors.get('customControlData.geadviseerd_beleid')}
                    jsEnum={BeleidOptions}
                    onChange={async (value) => {
                        await handleChangeBeleid(value);
                        props.validateOneCustomControl('beleid');
                    }}
                    onDoValidate={async () => await props.validateOneCustomControl('geadviseerd_beleid')}
                    placeholder="Kies beleid"
                    value={props.customControlData.geadviseerd_beleid}
                />
            </FormGroup>

            {props.customControlData.geadviseerd_beleid === BeleidOptions.verwijzing_oogarts && (
                <FormGroup
                    hasErrors={props.errors.has('customControlData.urgentie_oogarts')}
                    isRequired={true}
                    label="Urgentie"
                >
                    <SearchableEnumDropdown
                        automation="urgentie"
                        error={props.errors.get('customControlData.urgentie_oogarts')}
                        isSorted={true}
                        jsEnum={UrgenciesForConsultOogartsEnum}
                        onChange={async (value) => {
                            await props.handleChangeCustomControl({
                                urgentie_oogarts: value,
                                toelichting_urgentie: null,
                            });
                            props.validateOneCustomControl('urgentie_oogarts');
                        }}
                        onDoValidate={async () => await props.validateOneCustomControl('urgentie_oogarts')}
                        placeholder="Kies urgentie"
                        value={props.customControlData.urgentie_oogarts}
                    />
                </FormGroup>
            )}

            {props.customControlData.geadviseerd_beleid === BeleidOptions.verwijzing_optometrist && (
                <FormGroup
                    hasErrors={props.errors.has('customControlData.urgentie_optometrist')}
                    isRequired={true}
                    label="Urgentie"
                >
                    <SearchableEnumDropdown
                        automation="urgentie"
                        error={props.errors.get('customControlData.urgentie_optometrist')}
                        isSorted={true}
                        jsEnum={UrgenciesForConsultOptometrist}
                        onChange={async (value) => {
                            await props.handleChangeCustomControl({
                                urgentie_optometrist: value,
                                toelichting_urgentie: null,
                            });
                            props.validateOneCustomControl('urgentie_optometrist');
                        }}
                        onDoValidate={async () => await props.validateOneCustomControl('urgentie_optometrist')}
                        placeholder="Kies urgentie"
                        value={props.customControlData.urgentie_optometrist}
                    />
                </FormGroup>
            )}
            {(props.customControlData.urgentie_oogarts === UrgenciesForConsultOogartsEnum.anders ||
                props.customControlData.urgentie_optometrist === UrgenciesForConsultOptometrist.anders) && (
                <InputTextField
                    error={props.errors.get('customControlData.toelichting_urgentie')}
                    fieldKey="toelichting_urgentie"
                    hasErrors={props.errors.has('customControlData.toelichting_urgentie')}
                    isRequired={true}
                    label="common.remarks"
                    placeholder="Toelichting"
                    value={props.customControlData.toelichting_urgentie}
                />
            )}

            {props.customControlData.geadviseerd_beleid === BeleidOptions.revisie_orthoptist && (
                <FormGroup
                    hasErrors={props.errors.has('customControlData.termijn')}
                    isRequired={true}
                    label="Termijn"
                >
                    <InputPeriod
                        {...props}
                        errors={props.errors.get('customControlData.termijn')}
                        fieldKey="termijn"
                        value={props.customControlData.termijn}
                    />
                </FormGroup>
            )}

            {props.customControlData.geadviseerd_beleid === BeleidOptions.anders && (
                <InputTextField
                    error={props.errors.get('customControlData.toelichting_beleid')}
                    fieldKey="toelichting_beleid"
                    hasErrors={props.errors.has('customControlData.toelichting_beleid')}
                    isRequired={true}
                    label="common.remarks"
                    placeholder="Toelichting"
                    value={props.customControlData.toelichting_beleid}
                />
            )}
        </>
    );

    async function handleChangeBeleid(value: BeleidOptions | null) {
        const updatedBeleid = {
            geadviseerd_beleid: value,
            ...beleidInitialValues,
        };
        props.handleChangeCustomControl(updatedBeleid);
    }
}
